/**
 * Model pomocniczy dla kolumn typu 'enum' w systemie DataGrid.
 * Reprezentuje pojedynczą opcję w liście wyboru (Dropdown) lub filtrze.
 * Służy do mapowania surowych wartości technicznych (np. statusów z bazy danych)
 * na czytelne dla człowieka etykiety interfejsu.
 */
export class DataGridEnumColumnItem {

  /** Wartość techniczna (klucz) zwracana przez API.

   */
  public value: string;

  /** Etykieta prezentacyjna wyświetlana użytkownikowi w komórkach tabeli oraz w menu filtrów.
   */
  public label: string;

  constructor(value: string, label: string) {
    this.value = value;
    this.label = label;
  }
}
